import IframeRenderer from "../iframeRenderer";

const VendorScoreDashboardComponent = (props: any) => {
  const { data } = props;
  const iframeLink = `${data['Vendor - Vendor Score Dashboard']}`;
  return <IframeRenderer iframeLink={iframeLink} />
}

export default VendorScoreDashboardComponent;